{
  "Add to Calendar": "Add to Calendar",
  "All times are shown in {{timezoneAbbr}}. {{selectionInstructions}}": "All times are shown in {{timezoneAbbr}}. {{selectionInstructions}}",
  "An email confirmation has been sent to": "An email confirmation has been sent to",
  "An unexpected error occurred.": "An unexpected error occurred.",
  "Any provider (no preference)": "Any provider (no preference)",
  "Appointment Booked": "Appointment Booked",
  "Back": "Back",
  "Book Another Appointment": "Book Another Appointment",
  "Booking progress": "Booking progress",
  "Call or text us at": "Call or text us at",
  "Call the Practice": "Call the Practice",
  "Cancellation Policy": "Cancellation Policy",
  "Continue": "Continue",
  "Date and Time": "Date and Time",
  "Date and time": "Date and time",
  "Location": "Location",
  "Next Available": "Next Available",
  "Next availability:": "Next availability:",
  "Next available: ": "Next available: ",
  "Next week": "Next week",
  "Next {{weekCount}} weeks": "Next {{weekCount}} weeks",
  "No openings available from {{calendarStartDate}} to {{calendarEndDate}}": "No openings available from {{calendarStartDate}} to {{calendarEndDate}}",
  "No providers are available for this service.": "No providers are available for this service.",
  "No services are available for this location.": "No services are available for this location.",
  "No times have been selected": "No times have been selected",
  "Or select a specific provider": "Or select a specific provider",
  "Patient information": "Patient information",
  "Payment": "Payment",
  "Payment Received": "Payment Received",
  "Payment is unavailable for this appointment.": "Payment is unavailable for this appointment.",
  "Payment is unavailable right now. Please contact the practice.": "Payment is unavailable right now. Please contact the practice.",
  "Previous week": "Previous week",
  "Previous {{weekCount}} weeks": "Previous {{weekCount}} weeks",
  "Provider": "Provider",
  "Questions about your request?": "Questions about your request?",
  "Request Appointment": "Request Appointment",
  "Request to book": "Request to book",
  "Requested Date and Time": "Requested Date and Time",
  "Requested Provider": "Requested Provider",
  "Requested Service": "Requested Service",
  "Requested times": "Requested times",
  "Retry": "Retry",
  "Scheduling powered by": "Scheduling powered by",
  "Select a date": "Select a date",
  "Select a location": "Select a location",
  "Select a provider": "Select a provider",
  "Select a time for {{selectedDate}}": "Select a time for {{selectedDate}}",
  "Select between {{minimum}} and {{maximum}} time slots that fit in your schedule.": "Select between {{minimum}} and {{maximum}} time slots that fit in your schedule.",
  "Select {{count}} time slots that fit in your schedule, and we’ll reach out to you to confirm._one": "Select {{count}} time slot that fit in your schedule, and we’ll reach out to you to confirm.",
  "Select {{count}} time slots that fit in your schedule, and we’ll reach out to you to confirm._other": "Select {{count}} time slots that fit in your schedule, and we’ll reach out to you to confirm.",
  "Service": "Service",
  "Service Type": "Service Type",
  "Something went wrong on our end and your appointment was not booked.": "Something went wrong on our end and your appointment was not booked.",
  "Start Over": "Start Over",
  "Try Again": "Try Again",
  "Unable to load available time slots. Please try again.": "Unable to load available time slots. Please try again.",
  "Unable to load providers. Please try again.": "Unable to load providers. Please try again.",
  "Unable to load services. Please try again.": "Unable to load services. Please try again.",
  "We couldn't complete your booking.": "We couldn't complete your booking.",
  "Week date picker": "Week date picker",
  "We’ll confirm shortly": "We’ll confirm shortly",
  "What can we help you with?": "What can we help you with?",
  "You were away for a bit, so we ended your session. Nothing was saved.": "You were away for a bit, so we ended your session. Nothing was saved.",
  "You will be sent a confirmation SMS to": "You will be sent a confirmation SMS to",
  "You're almost there, {{locationName}} will get back to you to confirm your appointment": "You're almost there, {{locationName}} will get back to you to confirm your appointment",
  "Your session has expired": "Your session has expired",
  "pages": "pages",
  "{{amount}} received for {{serviceName}}": "{{amount}} received for {{serviceName}}"
}
